function detectCourier(trackingNumber) {
  const patterns = {
    Fedex: /^(?:\d{12}|\d{15}|\d{18}|\d{20}|\d{22}|\d{34})$/,
    Sendle: /^S[A-Za-z0-9]{5,7}$/,
    StarTrack: /^XTXZ/,
    TNT: /^(\d{9}|[A-Z]{3}\d{9,11})$/,
    UPS: /^(1Z[A-Z0-9]{16}|[0-9]{9}|T[0-9]{10}|[0-9]{12})$/,
    USPS: /^(94|93|92|95)[0-9]{20}$|^([A-Z]{2}[0-9]{9}US)$/,
    TFM: /^([A-Z]{2}\d{9}[A-Z]{2}|[A-Z]{6}\d{6})$/,
    CouriersPlease: /^(?:\d{11}|[A-Za-z]{6}[A-Za-z0-9]{11,})$/,
    Aramex: /^MP[A-Za-z0-9]{10}$/,
    DHL: /^\d{10}$/,
    Auspost: /^[A-Za-z0-9]+$/,
  };

  trackingNumber = trackingNumber.trim();

  for (const [courier, regex] of Object.entries(patterns)) {
    if (regex.test(trackingNumber)) {
      return courier;
    }
  }
  return "";
}

export { detectCourier };
